import { haveValue, formatPropertyAddress } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import {
  ShieldCheckIcon,
  DocIcon,
  OutlineShieldIcon,
} from "../../helper/svgHelper";

const InsuranceActivatedPopup = ({ show, onClose, onDone, propertyData }) => {
  const { _t } = useTranslator();

  if (!show) return null;

  const insuranceData = propertyData?.insurance_data;
  const simPayload = insuranceData?.simulationPayload;
  const isConfirmed = insuranceData?.status === "confirmed";
  const address = formatPropertyAddress(propertyData);

  const policyId = insuranceData?.policyNumber;
  const policyStart = simPayload?.fechaEfectoPoliza || null;
  const coverageMonths =
    simPayload?.garantias?.garantia?.[0]?.mesesCobImpago || 12;

  // payment_amount
  const annualPremium = haveValue(insuranceData?.payment_amount)
    ? `€${insuranceData.payment_amount} / ${_t("year")}`
    : null;

  const inquilinos = simPayload?.intervinientes?.inquilinos?.inquilino || [];
  const beneficiaryText =
    inquilinos.length > 0
      ? inquilinos
          .map((t) => {
            const name = [t?.nombreDocu, t?.apellido1]
              .filter(Boolean)
              .join(" ");
            const doc = t?.numeroDocu;
            return doc ? `${name} · ${doc}` : name;
          })
          .join(", ")
      : null;

  const policyDocUrl = haveValue(insuranceData?.policy_document)
    ? `${insuranceData.policy_document}`
    : null;

  const invoiceDocUrl = haveValue(insuranceData?.invoice_document)
    ? `${insuranceData.invoice_document}`
    : null;

  const rows = [
    haveValue(policyId) && {
      label: _t("policyId"),
      value: `#${policyId}`,
      valueClass: "ins-activated-policy-id",
    },
    haveValue(address) && {
      label: _t("coveredProperty"),
      value: address,
      valueClass: "ins-activated-value-bold",
    },
    haveValue(beneficiaryText) && {
      label: _t("beneficiary"),
      value: beneficiaryText,
      valueClass: "ins-activated-value-bold",
    },
    {
      label: _t("coverage"),
      value: `${coverageMonths} ${_t("months")}`,
      valueClass: "ins-activated-value-bold",
    },
    haveValue(policyStart) && {
      label: _t("policyStart"),
      value: policyStart,
      valueClass: "ins-activated-value-bold",
    },
  ].filter(Boolean);

  return (
    <div
      className="popup-overlay fixed inset-0 d-flex align-items-center justify-content-center z-50 wrapper-modal"
      style={{ zIndex: 9999 }}
    >
      <div className="ins-activated-card">
        <button className="ins-activated-close" onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>

        <div className="ins-activated-icon-wrap">
          <OutlineShieldIcon />
        </div>

        {isConfirmed ? (
          <>
            <h2 className="ins-activated-heading">{_t("policyActivated")}</h2>
            <p className="ins-activated-subheading">
              {_t("policyActivatedSubheading")}
            </p>

            <div className="ins-activated-details-card">
              {rows.map((row, i) => (
                <div key={i} className="ins-activated-row">
                  <span className="ins-activated-label">{row.label}</span>
                  <span className={row.valueClass}>{row.value}</span>
                </div>
              ))}
              {haveValue(annualPremium) && (
                <>
                  <div className="ins-activated-divider" />
                  <div className="ins-activated-row">
                    <span className="ins-activated-label">
                      {_t("annualPremium")}
                    </span>
                    <span className="ins-activated-value-bold">
                      {annualPremium}
                    </span>
                  </div>
                </>
              )}
            </div>

            <div className="ins-activated-footer">
              {haveValue(invoiceDocUrl) && (
                <button
                  className="ins-activated-btn ins-activated-btn-outline"
                  onClick={() => window.open(invoiceDocUrl, "_blank")}
                >
                  <DocIcon className="ins-activated-doc-icon" />
                  {_t("downloadInvoice")}
                </button>
              )}
              <button
                className="ins-activated-btn ins-activated-btn-outline ins-activated-btn-done"
                onClick={onDone}
              >
                {_t("done")}
              </button>
            </div>
          </>
        ) : (
          <>
            <h2 className="ins-activated-heading">
              {_t("processingInsurance")}
            </h2>
            <p className="ins-activated-subheading">
              {_t("processingTheInsurance")}
            </p>

            <div className="ins-activated-processing-wrap">
              <div className="ins-activated-spinner" />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InsuranceActivatedPopup;
